<template>
  <v-text-field
    filled
    :data-cy="dataCy"
    :label="label"
    v-model="localValue"
    :readonly="adminUnlocked"
    :append-icon="adminUnlocked ? mdiLock : mdiLockOpen"
    @click:append="adminUnlocked = !adminUnlocked"
    v-mask="'####-##-## ##:##'"
    hint="YYYY-MM-DD"
  />
</template>

<script>
import { mdiLock, mdiLockOpen } from '@mdi/js';
import basicModel from '@codehq/aurora-app-core/src/mixins/basicModel';

export default {
  name: 'AdminTextField',
  props: ['label', 'dataCy'],
  mixins: [basicModel],
  data() {
    return {
      /**
      * icons.
      */
      mdiLock,
      mdiLockOpen,
      /**
      * local variables.
      */
      adminUnlocked: true,
    };
  },
  watch: {
    value() {
      this.localValue = this.value;
    },
    localValue() {
      this.$emit('input', this.localValue);
    },
  },
  computed: {
    cy() {
      return this['data-cy'];
    },
  },
};
</script>
